module.exports = __webpack_public_path__ + "static/media/customize-icon.de861776.svg";